module.exports = __webpack_public_path__ + "img/sec1_1.8476343a.png";